import React, { Component } from 'react';
import PropTypes from 'prop-types';
import fx from 'money';
import styled from 'styled-components';
import axios from 'axios';
import FiatCurrencySelector from '../FiatCurrencySelector';
import accounting from 'accounting';
import getSymbolFromCurrency from 'currency-symbol-map';
import MediaQuery from 'react-responsive';
import FreeTextSearch from './FreeTextSearch';
import { media, redOrGreen, COLORS } from '../utils/style-utils';
import { renderMoney } from '../utils/money-utils';
import { sortBy } from '../utils/list-utils';
import ListItemTable from './ListItemTable';
import currencyMapping from '../FiatCurrencySelector/data/currencies-fi';
import Flag from '../Flag';
import {
  ListItemValue,
  CurrencyTableContainer,
  Toolbar,
  List,
  ListHeader,
  ListItemHeaderValue,
  ListItem,
  FreeTextSearchInput,
  sortOptions,
  CalculationInput,
} from './styles';

const FIAT_CURRENCY_API = 'https://currencyconverter.cloud/api/fiat';

const DISPLAY_MODES = {
  SHORT_LIST: 'short',
  FULL_LIST: 'full',
};

export default class CurrencyTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currencies: [],
      currencyShortList: [
        'EUR',
        'USD',
        'GBP',
        'SEK',
        'NOK',
        'DKK',
        'RUB',
        'THB',
      ],
      BaseCurrency: {
        value: props.defaultCurrency || 'USD',
        label: props.defaultCurrency
          ? currencyMapping[props.defaultCurrency].name
          : currencyMapping['USD'].name,
      },
      displayMode: DISPLAY_MODES.SHORT_LIST,
      sorting: {
        isDescending: sortOptions.isDescending,
        sortCol: sortOptions.values.MARKET_CAP,
      },
      isMobileDevice: false,
      calculationInputValue: 1,
      freeTextSearchValue: '',
    };
    fx.base = 'USD';
    this.onFreeTextSearchUpdate = this.onFreeTextSearchUpdate.bind(this);
    this.onCalculationInputChange = this.onCalculationInputChange.bind(this);
  }

  componentDidMount() {
    axios
      .get(FIAT_CURRENCY_API)
      .then(result => {
        fx.rates = result.data.currencies;
        const currencies = Object.keys(result.data.currencies)
          .filter(key => !!currencyMapping[key])
          .map(key => {
            return {
              code: key,
              price: result.data.currencies[key],
              name: currencyMapping[key].name,
            };
          });
        this.setState({ currencies: currencies });
      })
      .catch(e => {
        console.log(e);
      });
  }

  onCalculationInputChange = e => {
    const value = e.target.value;
    this.setState({ calculationInputValue: value });
  };

  updateBaseCurrency = currency => {
    this.setState({ BaseCurrency: currency });
  };

  calculateQuoteCurrency = currencyCode => {
    if (!currencyCode) return 0;

    try {
      let result = fx(1)
        .from(this.state.baseCurrency.value)
        .to(currencyCode)
        .toFixed(4);
      return result;
    } catch (e) {
      console.log('calculate QuoteCurrencyValue failed', e);
      //throw e
    }
  };

  listFilters = currencyItem => {
    if (this.state.displayMode === DISPLAY_MODES.FULL_LIST) return true;
    return (
      this.state.currencyShortList.includes(currencyItem.code) &&
      currencyItem.code !== this.state.BaseCurrency.value
    );
  };

  calculateCurrencyRate = quoteCurrency => {
    if (!this.state.calculationInputValue) return 0;
    return fx(this.state.calculationInputValue)
      .from(this.state.BaseCurrency.value)
      .to(quoteCurrency);
  };

  // Switch direction when new sort column is equal to previous
  // Also always sets sort direction to descending when changing sort column
  sortCurrencyList = value => {
    const isDescending =
      this.state.sorting.sortCol === value
        ? !this.state.sorting.isDescending
        : this.state.sorting.isDescending;
    const sortedList = this.state.currencies.sort(
      sortBy(value, isDescending, parseFloat)
    );
    this.setState({
      currencies: sortedList,
      sorting: {
        isDescending: isDescending,
        sortCol: value,
      },
    });
  };

  filterCurrencies = currency => {
    return (
      currency.name.toLowerCase().indexOf(this.state.freeTextSearchValue) >
        -1 ||
      currency.symbol.toLowerCase().indexOf(this.state.freeTextSearchValue) > -1
    );
  };

  onFreeTextSearchUpdate = e => {
    this.setState({ freeTextSearchValue: e.target.value.toLowerCase() });
  };

  render() {
    return (
      <CurrencyTableContainer>
        <Toolbar>
          <FiatCurrencySelector
            defaultCurrency={{ value: this.state.BaseCurrency }}
            onFiatCurrencyChange={this.updateBaseCurrency}
          />&nbsp;
          <CalculationInput
            value={this.state.calculationInputValue}
            onChange={this.onCalculationInputChange}
          />
        </Toolbar>
        <List>
          <ListHeader key={'header'}>
            <ListItemHeaderValue style={{ width: '40px' }} />
            <ListItemHeaderValue style={{ width: '200px' }}>
              Nimi
            </ListItemHeaderValue>
            <ListItemHeaderValue style={{ width: '80px' }}>
              Koodi
            </ListItemHeaderValue>
            <ListItemHeaderValue>Hinta</ListItemHeaderValue>
            <ListItemHeaderValue style={{ width: '80px' }} />
          </ListHeader>

          {this.state.currencies.filter(this.listFilters).map(currency => (
            <ListItem key={currency.code}>
              <ListItemValue style={{ width: '40px' }}>
                <Flag currency={currency.code} />
              </ListItemValue>
              <ListItemValue style={{ width: '200px' }}>
                {currency.name}
              </ListItemValue>
              <ListItemValue style={{ width: '80px' }}>
                {currency.code}
              </ListItemValue>
              <ListItemValue>
                {renderMoney(
                  this.calculateCurrencyRate(currency.code),
                  currency.code
                )}
              </ListItemValue>
              <ListItemValue style={{ width: '80px' }}>
                <a href={`/c/${currency.code.toLowerCase()}/`}>Lue lisää</a>
              </ListItemValue>
            </ListItem>
          ))}
        </List>
      </CurrencyTableContainer>
    );
  }
}

CurrencyTable.propTypes = {
  defaultCurrency: PropTypes.string,
};
